import Wallet from './components/Wallet';
import Statements from './components/Statements';
import Dashboard from './components/Dashboard';
import Mobile from './components/Mobile';
import MoneyTransfer from './components/MoneyTransfer';
import History from './components/History';
import Deposit from './components/Deposit';
import Train from './components/Train';
import Payments from './components/Payments';
import Transfers from './components/Transfers';
import Subscriptions from './components/Subscriptions';
import Inquiry from './components/Inquiry';
import Calendar from './components/Calendar';
import Credit from './components/Credit';
import Quittance from './components/Quittance';
import Settings from './components/Settings';
import RefillCredit from './components/RefillCredit';
import NotFound from './components/NotFound';

export default [
    {
        id: 'Wallet',
        path: '/wallet',
        component: Wallet,
    },
    {
        id: 'Statements',
        path: '/statements/:cardId?/:json?',
        component: Statements,
    },
    {
        id: 'Dashboard',
        path: '/',
        component: Dashboard,
    },
    {
        id: 'Mobile',
        path: '/mobile/:json?',
        component: Mobile,
    },
    {
        id: 'MoneyTransfer',
        path: '/money-transfer/:json?',
        component: MoneyTransfer,
    },
    {
        id: 'History',
        path: '/history/:json?',
        component: History,
    },
    {
        id: 'Deposit',
        path: '/deposit/:action',
        component: Deposit,
    },
    {
        id: 'Transfers',
        path: '/transfer/:action',
        component: Transfers,
    },
    {
        id: 'Train',
        path: '/train/:action',
        component: Train,
    },
    {
        id: 'Subscriptions',
        path: '/subscriptions',
        component: Subscriptions,
    },
    {
        id: 'Payments',
        path: '/payments',
        component: Payments,
    },
    {
        id: 'Inquiry',
        path: '/inquiry/:json?',
        component: Inquiry,
    },
    {
        id: 'Calendar',
        path: '/calendar/:json?',
        component: Calendar,
    },
    {
        id: 'Credit',
        path: '/credit/:json?',
        component: Credit,
    },
    {
        id: 'Quittance',
        path: '/quittance/:json?',
        component: Quittance,
    },
    {
        id: 'Settings',
        path: '/settings/:action/:json?',
        component: Settings,
    },
    {
        id: 'RefillCredit',
        path: '/refill-credit/:json?',
        component: RefillCredit,
    },
    {
        id: 'NotFound',
        component: NotFound,
    },
];
